export default {
  walkthroughDesigner: {
    path: '/designer/walkthrough/:id?', // ? indicates an optional parameter
    name: 'designer-walkthrough',
    i18nNamespace: 'vue.main.*',
    featureFlag: 'WalkthroughsFeatureFlag',
  },
  stateDesigner: {
    path: '/designer/workflow/:id',
    name: 'designer-workflow',
  },
  listViewVisualisation: {
    path: '/list-view-visualisation',
    name: 'list-view-visualisation',
    i18nNamespace: 'vue.visualisation.*',
  },
  i18nLookup: {
    path: '/i18n-lookup/:id',
    name: 'i18nlookup',
  },
  i18nForm: {
    path: '/i18n-form/:id',
    name: 'i18nForm',
  },
  bulkUpdate: {
    path: '/bulk-update',
    name: 'BulkUpdate',
    i18nNamespace: 'vue.bulkupdate.*',
  },
  locationMap: {
    path: '/map',
    name: 'map',
    i18nNamespace: 'vue.mapping.*',
  },
  locationMapDraw: {
    path: '/polygon-map-draw',
    name: 'PolygonMapDraw',
    i18nNamespace: 'vue.mapping.*',
  },
  multiLocationMap: {
    path: '/multi-map',
    name: 'multimap',
    i18nNamespace: 'vue.mapping.*',
  },
  sustainabilityDataEntry: {
    path: '(/)?/sustainability/questionnaire',
    name: 'sustainability-questionnaire',
    i18nNamespace: 'Sustainability.*',
  },
  importsStatus: {
    path: '/dashboard/import/status',
    name: 'imports-status',
    i18nNamespace: 'ImportsStatus.*',
  },
  e360Container: {
    path: '*',
    name: 'E360Container',
    i18nNamespace: 'vue.main.*',
  },
}
